import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M0.175781 11.621C0.319664 11.621 0.294968 11.6653 0.429272 11.6917C0.788982 11.7623 1.3988 11.9744 2.04628 12.1864C3.34125 12.6811 4.92398 13.4585 6.147 14.7305C7.37003 15.932 8.16139 17.2747 8.59305 18.3348C8.80888 18.9001 8.95276 19.3242 9.09665 19.6775C9.16859 19.8189 9.16859 19.9602 9.16859 20.0309C9.16859 20.1016 9.16859 20.1016 9.16859 20.1016C9.16859 20.1016 9.16859 20.1016 10.2477 19.8895C11.3269 19.6775 11.3269 19.6775 11.3269 19.6775C11.3269 19.6775 11.3269 19.6775 11.3269 19.6069C11.3269 19.6069 11.3269 19.5362 11.3269 19.4655C11.3269 19.3242 11.2549 19.1828 11.183 18.9708C11.0391 18.5468 10.8952 18.0521 10.6074 17.416C10.0319 16.144 9.16859 14.5185 7.65779 13.1051C7.08226 12.5397 6.43478 12.045 5.78729 11.621L50.1758 11.621V8.79414L5.64341 8.79414C6.36283 8.37011 7.08226 7.80474 7.80168 7.09803C9.24053 5.6846 10.1758 3.98849 10.7513 2.78707C11.0391 2.15103 11.183 1.58566 11.3269 1.2323C11.3988 1.02029 11.3988 0.878948 11.4707 0.737606C11.4707 0.666935 11.4707 0.666933 11.4707 0.596262C11.4707 0.596262 11.4707 0.59626 11.4707 0.525589C11.4707 0.525589 11.4707 0.525589 10.3916 0.313576C9.31247 0.101563 9.31247 0.101563 9.31247 0.101563V0.172232C9.31247 0.242903 9.24053 0.384247 9.24053 0.525589C9.16859 0.878946 8.95276 1.30297 8.73693 1.86835C8.23333 2.92842 7.51391 4.34184 6.29089 5.47259C5.06786 6.74467 3.48513 7.52206 2.19017 8.01676C1.54269 8.22877 0.967148 8.44078 0.607437 8.51146C0.391609 8.58213 0.247723 8.58213 0.175781 8.58213V9.21817V10.8436V11.621Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'slider-arrow-left',
  props: {
  color: { type: String, required: true },
},
  setup(__props) {

// eslint-disable-next-line no-undef


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "51",
    height: "21",
    viewBox: "0 0 51 21",
    fill: __props.color,
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})